import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { ViewButton, EditButton } from '../Common/DataTable/tableActionButtons';
import { getFilter, getLabel, getSort } from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (
  openViewModal,
  openEditModal,
  openArchiveModal,
  countries,
  campaigns,
) => [
  {
    title: 'Name',
    name: 'name',
    sort: true,
  },
  {
    title: 'Country',
    name: 'countryId',
    sort: true,
    formatterComponent: ({ value }) => getLabel(value, countries),
    sorting: (a, b) =>
      getSort(getLabel(a, countries), getLabel(b, countries)),
    filter: (value, filter) =>
      getFilter(getLabel(value, countries), filter.value),
  },
  {
    title: 'Campaign',
    name: 'campaignId',
    sort: true,
    formatterComponent: ({ value }) => getLabel(value, campaigns),
    sorting: (a, b) =>
      getSort(getLabel(a, campaigns), getLabel(b, campaigns)),
    filter: (value, filter) =>
      getFilter(getLabel(value, campaigns), filter.value),
  },
  {
    title: 'Public URL',
    name: 'publicUrl',
    formatterComponent: ({ value, row }) =>
      !row.archived && value ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ) : (
        ''
      ),
    filter: (value, filter) => getFilter(value || '', filter.value),
    sorting: (a, b) => getSort(a || '', b || ''),
  },
  {
    title: 'Archived',
    name: 'archived',
    width: 120,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-warning font-size-12">YES</span>
      ) : (
        <span className="badge badge-success font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'yes' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'yes' : 'no', b ? 'yes' : 'no'),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => `${moment(value).fromNow()}`,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
  },
  {
    title: 'Action',
    name: 'action',
    width: 150,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
        <li className="list-inline-item px-1">
          <Link
            to="#"
            id={'archive_lp_' + row.id}
            onClick={(event) => {
              event.preventDefault();
              openArchiveModal(row);
            }}>
            <i className="bx bx-archive-in"></i>
            <UncontrolledTooltip
              placement="top"
              target={'archive_lp_' + row.id}>
              Archive
            </UncontrolledTooltip>
          </Link>
        </li>
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
